<template>
  <IconSvgBase :class="$style.icon" :view-width="20" :view-height="18">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.99988 11.25C9.31071 11.25 8.74988 10.6892 8.74988 10C8.74988 9.31083 9.31071 8.75 9.99988 8.75C10.689 8.75 11.2499 9.31083 11.2499 10C11.2499 10.6892 10.689 11.25 9.99988 11.25ZM9.99988 7.08333C8.39155 7.08333 7.08321 8.39166 7.08321 10C7.08321 11.6083 8.39155 12.9167 9.99988 12.9167C11.6082 12.9167 12.9165 11.6083 12.9165 10C12.9165 8.39166 11.6082 7.08333 9.99988 7.08333ZM10.183 14.1647C6.59463 14.248 4.2538 11.1788 3.47713 9.99633C4.33213 8.65883 6.48546 5.9205 9.81713 5.8355C13.3913 5.74466 15.7455 8.82133 16.5221 10.0038C15.668 11.3413 13.5138 14.0797 10.183 14.1647ZM18.223 9.5855C17.6913 8.65883 14.7546 4.01383 9.77463 4.16966C5.16796 4.28633 2.4888 8.34466 1.77713 9.5855C1.62963 9.84216 1.62963 10.158 1.77713 10.4147C2.3013 11.3288 5.13463 15.833 10.0205 15.833C10.0888 15.833 10.1571 15.8322 10.2255 15.8305C14.8313 15.713 17.5113 11.6555 18.223 10.4147C18.3696 10.158 18.3696 9.84216 18.223 9.5855Z"
    />
  </IconSvgBase>
</template>

<script setup lang="ts">
import IconSvgBase from '@/components/icons/IconSvgBase.vue'
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;
  fill: currentcolor;
}
</style>
